// extracted by mini-css-extract-plugin
export default {"container":"PenaltyInfo_container__4CtNO","text":"PenaltyInfo_text__pX7ui","list":"PenaltyInfo_list__KqK5-"};